import React from "react";
import styled from "styled-components";
import colors from "../../styles/colors";

export default styled.div`
ul, ol {
  color: ${colors.main};
  font-size: 0.9em;
  font-weight: 400;
  letter-spacing: 0px;
  list-style: none;
  margin-top: 0;
  padding-left: 0;
  text-transform: none;

  > li {
    line-height: 1.3em;
    margin-top: 0.55em;
  }
}

ol {
    list-style-type: decimal;
    padding-left: 1.8125em;
    margin-top: 0.65em;    
    position: relative;

    & + h2 {
      margin-top: 1.75em;
    }

    > li {
      
      margin-left: -0.4em;
      
      padding-left: 0.4em; 
      position: relative;

      &:nth-child(n+10) {
        margin-left: initial;
        padding-left: 0;
      }
    }
  }

  span.tipped {
    cursor: pointer;
    background-image: linear-gradient(
      to right,
      ${colors.main} 100%,
      transparent 100%
    );
    background-position: 0 1.35em;
    background-repeat: no-repeat;
    background-size: 100% 1px;
    margin-bottom: -5px;
    padding-bottom: 5px;
    transition: all 0.075s ease;

    &:hover {
      /* background-size: 100% 3px;
      transition: all 0.075s ease; */
    }
    &.extraHelp {
      background-image: linear-gradient(
        to right,
        ${colors.main} 50%,
        transparent 50%
      );
      background-repeat: repeat-x;
      background-size: 4px 1px;
      transition: none;

      &:hover {
        /* background-image: linear-gradient(
          to right,
          ${colors.main} 100%,
          transparent 100%
        );
        background-size: 100% 3px;
        transition: all 0.075s ease; */
      }
    }
  }  
`;



// WEBPACK FOOTER //
// ./src/components/grammatica/Wrapper.js